module.exports = __webpack_public_path__ + "img/ru_failure_1.39f4fa1b.png";